import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import QualityRecord from "./QualityRecord";


const styles = theme => ({});


@withStyles(styles)
class QualityRecords extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        report: PropTypes.object.isRequired
    };

    state = {};

    render() {
        const {classes, report} = this.props;

        return (
            <React.Fragment>
                {report.qual_record.map((record, recidx) => (
                        <QualityRecord key={"quality-record-" + recidx } record={record}/>
                    )
                )}
            </React.Fragment>
        );
    }
}

export default QualityRecords;